export default {"src":"/_next/static/media/cooking.91ce2500.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};